import { render } from "./RouterLifecycle.vue?vue&type=template&id=50cc0d05&scoped=true&lang=true"
import script from "./RouterLifecycle.vue?vue&type=script&lang=js"
export * from "./RouterLifecycle.vue?vue&type=script&lang=js"

import "./RouterLifecycle.vue?vue&type=style&index=0&id=50cc0d05&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc0d05"]])

export default __exports__